import { combineReducers } from 'redux';
import location from './reducer-router';
import query from '../../contactUs/reducers/reducer-query-params';
import notifier from '../../contactUs/reducers/reducer-notifier';
import helpcenterAlerts from '../../contactUs/reducers/reducer-helpcenter-alerts';
import autoComplete from '../../contactUs/reducers/reducer-auto-complete';
import searchFilters from './reducer-search-filter-form';
import searchResult from './reducer-search-results';
import contactReason from './reducer-top-contact-reason';
import mobileFilter from './reducer-mobile-filter';
import sample from './reducer-sample';

import contentToggle from './reducer-content-toggle';
import article from './reducer-article-panel';
import topicList from './reducer-topic-list';
import popular from './reducer-popular-list';
import articleList from './reducer-article-list';
import breadcrumb from './reducer-breadcrumb';
import community from './reducer-community-results';
import openCase from './reducer-open-case';
import machineArticle from './reducer-machine-article';
import chatBot from './reducer-chat-bot';
import chatBotFAQ from '../../contactUs/reducers/reducer-chat-bot';
import chatInEligibleModal from '../../contactUs/reducers/reducer-chat-ineligible-modal';
import speechRecognition from '../../contactUs/reducers/reducer-speech-recognition';
import postChatBotEligibility from '../../contactUs/reducers/reducer-postchatbot-eligibility';

import modal from '../../contactUs/reducers/reducer-login-modal';
import app from '../reducers/reducer-app';
import defaultPCCArticles from './reducer-default-PCC';
import authPrompt from './reducer-auth-prompt';

// SAMPLE APP state

// {
//   location,
//   topicTree: {
//     experience: 'personal',
//     topicTree: [],
//   },
//   topicList: {
//     experience: 'personal',
//     topicId: '',
//     topicList: [],
//   },
//   article: {
//     experience: 'personal',
//     articleId: '',
//     relatedArticle: [],
//   },
// };

const rootReducers = combineReducers({
  location,
  query,
  notifier,
  helpcenterAlerts,
  autoComplete,
  searchFilters,
  searchResult,
  contactReason,
  mobileFilter,
  topicTree: sample,
  topicList,
  contentToggle,
  article,
  articleList,
  machineArticle,
  popular,
  breadcrumb,
  community,
  chatBot,
  chatBotFAQ,
  openCase,
  modal,
  chatInEligibleModal,
  speechRecognition,
  postChatBotEligibility,
  app,
  defaultPCCArticles,
  authPrompt,
});

export default rootReducers;
